<div class="multipleChoiceOption" [class.inEditMode]="inEditMode">
	@for (option of item.options; track $index) {
		<div class="checkBoxContainer" [@zoomOutOnLeave] [class.inEditMode]="inEditMode">
			@if (inEditMode) {
				<button
					style="align-self: center"
					mat-icon-button
					color="warn"
					class="remove"
					[@zoomInOnEnter]
					(click)="onRemoveOption.emit($index)"
				>
					<mat-icon fontSet="fad" fontIcon="fa-trash-alt" />
				</button>
			}

			<mat-checkbox
				[disabled]="mode !== AssessablePanelMode.Answer"
				[indeterminate]="false"
				(change)="handleCheckboxChange($index, $event.checked)"
				[checked]="item.answer?.includes($index)"
			>
				@if (inEditMode) {
					<div [@zoomInOnEnter] class="itemEdit">
						<ng-container *ngTemplateOutlet="optionTemplate; context: {$implicit: {i: $index}}" />
					</div>
				} @else {
					<sim-rich-text-editor-view [@zoomInOnEnter] [content]="option" />
				}
			</mat-checkbox>

			<ng-container *ngTemplateOutlet="scoreTemplate; context: {$implicit: {i: $index}}" />
		</div>
	}

	@if (!inEditMode && (!item.options || item.options?.length === 0)) {
		<div class="noOptionsAddedYet">
			<div class="text">
				{{ T.SHARED_EXPANSION_NO_OPTION_ADDED | translate }}
				{{ T.SHARED_EXPANSION_CLICK_TO_ADD_OPTION | translate }}
			</div>
		</div>
	}
</div>

@if (inEditMode) {
	<div class="addOptionButtonContainer" [@zoomInOnEnter]>
		<button class="addOptionButton" mat-mini-fab color="accent" (click)="onAddOption.emit()">
			<mat-icon fontSet="fa" fontIcon="fa-plus" inline />
		</button>

		<ng-container *ngTemplateOutlet="rightOfAddOptionTemplate" />
	</div>
}
